import { render, staticRenderFns } from "./NMBRButtonsWrapper.vue?vue&type=template&id=0a050144&scoped=true&"
import script from "./NMBRButtonsWrapper.vue?vue&type=script&lang=js&"
export * from "./NMBRButtonsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NMBRButtonsWrapper.vue?vue&type=style&index=0&id=0a050144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a050144",
  null
  
)

export default component.exports